export const RoleEnum = {
    ROLE_VO_ADMIN: {
        name: "Админ ФЦ",
        description: "Сотрудник который может импортировать данные",
    },
    ROLE_VO_ADMIN2: {
        name: "Админ ФЦ(просмотр)",
        description: "Сотрудник который может просмотреть данные",
    },
    ROLE_VO_MANAGER: {
        name: "Менеджер ФЦ",
        description: "Сотрудник Финансового Центра, ответственный за работу с расчетами и взаимодействие с ВУЗами",
    },
    ROLE_VO_UNIVERSITY: {
        name: "Менеджер ВУЗа",
        description: "Куратор ВУЗа с возможностью работы с бизнес-процессами и отчетами ВУЗа",
    },
    ROLE_VO_ACCOUNTANT: {
        name: "Бухгалтерия ФЦ",
        description: "Сотрудник бухгалтерии, проверяющий ЭСФ и выгружающие отчеты по платежным требованиям",
    },
    ROLE_VO_RECTOR: {
        name: "Ректор ВУЗа",
        description: "Глава ВУЗа, с возможностью подписания отчетов",
    },
};
